import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
  createOrganization,
  getOrganization,
  updateOrganization,
  deleteOrganization,
} from "../api/orgApi";
import "./css/Organizations.css";
import OrganizationModal from "./OrganizationModal";
import AccessControl from "../components/AccessControl";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";

const Organizations = () => {
  const navigate = useNavigate();
  const adminData = localStorage.getItem("admin");
  const userData = adminData ? JSON.parse(adminData) : null;
  const [organizations, setOrganizations] = useState([]);
  const [search, setSearch] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState(null);
 const [loading, setLoading] = useState(false);

  const fetchOrganizations = async () => {
    try {
      setLoading(true)
      const res = await getOrganization();
      setLoading(false)
      if (res.success !== false) {
console.log("Fetched organizations:", res.orgs);
        setOrganizations(res.orgs || []);
      } else {
        toast.error(res.error || "Failed to load organizations");
      }
    } catch {
      toast.error("Failed to load organizations");
    }
  };

  useEffect(() => {
    fetchOrganizations();
  }, []);

  const deleteOrg = async (orgId) => {
    if (!window.confirm("Delete this organization?")) return;
    try {
      const res = await deleteOrganization(orgId);
      if (res.success !== false) {
        toast.success("Organization deleted successfully");
        fetchOrganizations();
      } else {
        toast.error(res.error || "Failed to delete organization");
      }
    } catch {
      toast.error("Failed to delete organization");
    }
  };

  return (
    <div className="org-container">
     <AccessControl
        allowedRoles={["SUPERADMIN", "ADMIN","HR"]}
        redirectTo="/404"
      />
      {loading && (
             <Loader />
            )}
      <div className="org-header-bar">
        <h2 className="org-title">🏢 Organizations</h2>
       {["SUPERADMIN", "ADMIN"].includes(userData?.role) && organizations.length === 0 && (
        <button
          className="btn btn-success"
          onClick={() => {
            setSelectedOrg(null);
            setIsModalOpen(true);
          }}
        >
          + Add Organization
        </button>
      )}
       
      </div>

      <div className="org-search">
        <input
          type="text"
          placeholder="Search organizations..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="org-grid">
        {organizations
          .filter((org) =>
            org.name?.toLowerCase().includes(search.toLowerCase())
          )
          .map((org) => (
            <div key={org._id} className="org-card">
              <div className="org-card-header">
                <img
                  src={org.logo || "/default-logo.png"}
                  alt="logo"
                  className="org-logo"
                />
                <div>
                  <h3 className="org-name">{org.name}</h3>
                  <span className={`plan-badge ${org.plan?.toLowerCase()}`}>
                    {org.plan}
                  </span>
                </div>
              </div>

              <div className="org-details">
                <p><b>Email:</b> {org.email}</p>
                <p><b>Phone:</b> {org.phone || "N/A"}</p>
                <p>
                  <b>Address:</b>{" "}
                  {org.address}
                </p>
              </div>

              <div className="org-actions">
                <button
                  className="btn btn-sm btn-info"
                  onClick={() => navigate(`/organizations/${org.orgId}/zones`)}
                >
                  🏬 Zones
                </button>

                {["SUPERADMIN"].includes(userData?.role) && (
                  <button
                    className="btn-outline-green"
                    onClick={() => {
                      setSelectedOrg(org);
                      setIsModalOpen(true);
                    }}
                  >
                    ✏️ Edit
                  </button>
                )}

                {["SUPERADMIN"].includes(userData?.role) && (
                  <button
                    className="btn btn-danger"
                    onClick={() => deleteOrg(org.orgId)}
                  >
                    🗑️ Delete
                  </button>
                )}
              </div>
            </div>
          ))}
      </div>

      <OrganizationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={async (data) => {
          if (selectedOrg) {
            await updateOrganization(selectedOrg.orgId, data);
            toast.success("Organization updated");
          } else {
            await createOrganization(data);
            toast.success("Organization created");
          }
          fetchOrganizations();
          setIsModalOpen(false);
        }}
        org={selectedOrg}
      />
    </div>
  );
};

export default Organizations;